import { deriveQueryStringHelpersFromSearchString } from '@shared/core/queryString';
import { CartSections } from '../ShoppingCart.constants';

export const getCartDeepLinkSection = (search: string | undefined): CartSections | null => {
  const shoppingCartParam = deriveQueryStringHelpersFromSearchString(search).getValueString('shopping-cart');

  switch (shoppingCartParam) {
    case 'active':
    case 'history':
      return CartSections.HISTORY;
    case 'cart':
      return CartSections.CART;
    default:
      return null;
  }
};
